{
    "name": "@whiz-cart/store-manager-ui",
    "version": "4.153.0",
    "private": true,
    "type": "module",
    "scripts": {
        "build": "runp -i -n=10 build:clean build:compile",
        "build:clean": "rimraf \"dist/**/*\"",
        "build:compile": "cross-env NODE_OPTIONS=--max_old_space_size=5000 vite build",
        "start": "vite --mode dev",
        "start:caf-test": "vite --mode caf-test",
        "start:test": "vite --mode test",
        "start:prod": "vite --mode prod",
        "test": "vitest run",
        "test:watch": "vitest",
        "translate:download": "localazy download",
        "lint": "wc-lint",
        "fix": "wc-lint --fix",
        "typecheck": "wc-lint --no-format --no-lint",
        "knip": "knip",
        "analyze-bundle": "pnpx vite-bundle-analyzer --mode static"
    },
    "dependencies": {
        "@azure/msal-browser": "^3.24.0",
        "@coreui/icons": "catalog:frontend",
        "@dnd-kit/core": "^6.3.1",
        "@dnd-kit/sortable": "^10.0.0",
        "@elastic/elasticsearch": "^8.5.0",
        "@emotion/react": "catalog:frontend",
        "@emotion/styled": "catalog:frontend",
        "@fontsource/fira-sans": "catalog:fonts",
        "@fontsource/fira-sans-condensed": "catalog:fonts",
        "@formatjs/intl-durationformat": "^0.2.2",
        "@fortawesome/fontawesome-svg-core": "catalog:frontend",
        "@fortawesome/pro-duotone-svg-icons": "catalog:frontend",
        "@fortawesome/pro-light-svg-icons": "catalog:frontend",
        "@fortawesome/pro-regular-svg-icons": "catalog:frontend",
        "@fortawesome/pro-solid-svg-icons": "catalog:frontend",
        "@fortawesome/react-fontawesome": "catalog:frontend",
        "@grafana/faro-react": "^1.19.0",
        "@grafana/faro-web-sdk": "^1.19.0",
        "@grafana/faro-web-tracing": "^1.19.0",
        "@hello-pangea/dnd": "^18.0.1",
        "@marsidev/react-turnstile": "catalog:frontend",
        "@mui/icons-material": "catalog:frontend",
        "@mui/lab": "catalog:frontend",
        "@mui/material": "catalog:frontend",
        "@mui/system": "catalog:frontend",
        "@mui/x-data-grid": "catalog:frontend",
        "@mui/x-date-pickers": "catalog:frontend",
        "@protobuf-ts/runtime-rpc": "2.9.4",
        "@whiz-cart/node-shared": "workspace:",
        "@whiz-cart/services-web": "1.0.134989",
        "@whiz-cart/ui-shared": "workspace:",
        "@zxing/library": "^0.19.1",
        "chart.js": "catalog:frontend",
        "chartjs-adapter-date-fns": "catalog:frontend",
        "classnames": "catalog:frontend",
        "core-js": "catalog:",
        "cross-state": "catalog:",
        "date-fns": "catalog:",
        "fast-deep-equal": "catalog:",
        "firebase": "catalog:",
        "formik": "^2.2.9",
        "formik-mui": "^4.0.0-alpha.3",
        "fuse.js": "catalog:",
        "immer": "catalog:",
        "jodit": "^4.7.4",
        "jodit-react": "^5.2.5",
        "jsondiffpatch": "^0.4.1",
        "jwt-decode": "^4.0.0",
        "leaflet": "catalog:frontend",
        "leaflet-geosearch": "^3.0.6",
        "localforage": "catalog:frontend",
        "lodash": "catalog:",
        "moment": "catalog:",
        "moment-timezone": "catalog:",
        "mutative": "catalog:",
        "notistack": "^3.0.2",
        "object-hash": " ^2.0.5",
        "powerbi-client": "^2.23.1",
        "powerbi-client-react": "^1.3.3",
        "qs": "catalog:",
        "react": "catalog:frontend",
        "react-archer": "catalog:frontend",
        "react-chartjs-2": "^5.3.0",
        "react-datasheet": "^1.4.12",
        "react-datepicker": "^8.8.0",
        "react-dom": "catalog:frontend",
        "react-highlight-words": "^0.21.0",
        "react-hook-form": "^7.65.0",
        "react-leaflet": "catalog:frontend",
        "react-redux": "catalog:frontend",
        "react-router": "catalog:frontend",
        "react-router-dom": "catalog:frontend",
        "react-select": "^5.3.2",
        "react-swipeable": "^7.0.0",
        "react-toastify": "^5.5.0",
        "react-zoom-pan-pinch": "catalog:frontend",
        "reconnecting-websocket": "^4.4.0",
        "redux": "catalog:frontend",
        "redux-persist": "catalog:frontend",
        "redux-thunk": "catalog:frontend",
        "reset-css": "catalog:frontend",
        "schummar-state": "catalog:frontend",
        "schummar-table": "catalog:frontend",
        "schummar-translate": "catalog:frontend",
        "semver": "catalog:",
        "smoothscroll-polyfill": "^0.4.4",
        "socket.io": "catalog:backend",
        "socket.io-client": "catalog:",
        "swiper": "^11.0.5",
        "uuid": "catalog:",
        "workbox-core": "catalog:frontend",
        "workbox-precaching": "catalog:frontend",
        "workbox-routing": "catalog:frontend",
        "workbox-strategies": "catalog:frontend",
        "xlsx": "^0.18.5",
        "zod": "catalog:"
    },
    "devDependencies": {
        "@babel/plugin-proposal-decorators": "catalog:frontend",
        "@localazy/cli": "catalog:",
        "@rolldown/plugin-babel": "catalog:frontend",
        "@rolldown/plugin-emotion": "catalog:frontend",
        "@schummar/runp": "catalog:",
        "@types/history": "^4.7.11",
        "@types/leaflet": "catalog:frontend",
        "@types/lodash": "catalog:",
        "@types/node": "catalog:backend",
        "@types/object-hash": "catalog:frontend",
        "@types/qs": "catalog:",
        "@types/react": "catalog:frontend",
        "@types/react-big-calendar": "1.16.3",
        "@types/react-dom": "catalog:frontend",
        "@types/react-highlight-words": "^0.20.0",
        "@types/react-redux": "catalog:frontend",
        "@types/react-router": "catalog:frontend",
        "@types/react-router-dom": "catalog:frontend",
        "@types/semver": "catalog:",
        "@types/smoothscroll-polyfill": "^0.3.4",
        "@types/uuid": "catalog:",
        "@vitejs/plugin-react": "catalog:frontend",
        "@whiz-cart/storybook": "workspace:",
        "@whiz-cart/workspace-configs": "workspace:",
        "@whiz-cart/workspace-scripts": "workspace:",
        "autobind-decorator": "^2.4.0",
        "azure-devops-node-api": "^14.0.2",
        "babel-plugin-react-compiler": "catalog:frontend",
        "cross-env": "catalog:",
        "knip": "catalog:",
        "less": "catalog:frontend",
        "react-big-calendar": "1.19.4",
        "react-to-print": "^3.2.0",
        "rimraf": "catalog:",
        "rollup-plugin-visualizer": "5.8.3",
        "runtypes": "catalog:",
        "typescript": "catalog:",
        "vite": "catalog:",
        "vite-bundle-analyzer": "catalog:frontend",
        "vite-plugin-pwa": "catalog:frontend",
        "vite-plugin-svgr": "catalog:frontend",
        "vitest": "catalog:"
    },
    "volta": {
        "extends": "../../package.json"
    }
}
